(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-antes-despues"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBaf(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var sliders = scope.querySelectorAll('.baf__slider');
      sliders.forEach(function (slider) {
        if (slider.dataset.bafReady) { return; }
        slider.dataset.bafReady = '1';
        var before = slider.querySelector('.baf__before');
        var handle = slider.querySelector('.baf__handle');
        if (!before || !handle) { return; }
        var pos = parseFloat(slider.getAttribute('data-pos'));
        if (isNaN(pos)) { pos = 50; }
        var dragging = false;

        function set(p) {
          p = Math.max(0, Math.min(100, p));
          pos = p;
          before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
          handle.style.left = p + '%';
          handle.setAttribute('aria-valuenow', Math.round(p));
        }
        set(pos);

        function fromEvent(e) {
          var rect = slider.getBoundingClientRect();
          var clientX = e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX;
          set(((clientX - rect.left) / rect.width) * 100);
        }
        function down(e) { dragging = true; fromEvent(e); }
        function move(e) { if (!dragging) { return; } fromEvent(e); if (e.cancelable && e.type === 'touchmove') { e.preventDefault(); } }
        function up() { dragging = false; }

        slider.addEventListener('mousedown', down);
        slider.addEventListener('touchstart', down, { passive: true });
        window.addEventListener('mousemove', move);
        window.addEventListener('touchmove', move, { passive: false });
        window.addEventListener('mouseup', up);
        window.addEventListener('touchend', up);
        handle.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { set(pos - 2); e.preventDefault(); }
          if (e.key === 'ArrowRight') { set(pos + 2); e.preventDefault(); }
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initBaf(document); });
    } else {
      initBaf(document);
    }
    document.addEventListener('shopify:section:load', function (e) { initBaf(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-atributos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeat(root) {
      if (!root || root.dataset.featReady === '1') return;
      root.dataset.featReady = '1';
      var track = root.querySelector('.feat__track');
      var dots = Array.prototype.slice.call(root.querySelectorAll('.feat__dot'));
      if (!track || dots.length === 0) return;

      function itemWidth() {
        var it = track.querySelector('.feat__item');
        if (!it) return 1;
        var cs = getComputedStyle(track);
        var gap = parseInt(cs.columnGap || cs.gap || '0', 10) || 0;
        return it.offsetWidth + gap;
      }
      function setActive(i) {
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / itemWidth());
          if (i < 0) i = 0;
          if (i > dots.length - 1) i = dots.length - 1;
          setActive(i);
          ticking = false;
        });
      });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = parseInt(d.getAttribute('data-i'), 10) || 0;
          track.scrollTo({ left: i * itemWidth(), behavior: 'smooth' });
        });
      });
    }
    document.querySelectorAll('.feat').forEach(initFeat);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.feat'); if (el) initFeat(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-banner-destacado"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPfb(root) {
      if (!root || root.dataset.pfbReady === '1') return;
      root.dataset.pfbReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('.pfb__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.pfb__dot'));
      var prev = root.querySelector('.pfb__nav--prev');
      var next = root.querySelector('.pfb__nav--next');
      if (slides.length <= 1) return;

      var current = 0;
      var timer = null;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = (parseFloat(root.getAttribute('data-speed')) || 5) * 1000;

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
      }
      function nextSlide() { show(current + 1); }
      function start() { if (autoplay) { stop(); timer = setInterval(nextSlide, speed); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
      if (next) next.addEventListener('click', function () { show(current + 1); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-i'), 10) || 0); start(); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    }

    document.querySelectorAll('.pfb').forEach(initPfb);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.pfb');
      if (el) initPfb(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-como-funciona"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHiw(root) {
      if (!root || root.dataset.hiwReady === '1') return;
      root.dataset.hiwReady = '1';
      if (root.getAttribute('data-single') !== 'true') return;
      var items = Array.prototype.slice.call(root.querySelectorAll('.hiw__step'));
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) { items.forEach(function (o) { if (o !== d && o.open) o.open = false; }); }
        });
      });
    }
    document.querySelectorAll('.hiw').forEach(initHiw);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.hiw'); if (el) initHiw(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-destacados"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFp(root) {
      if (!root || root.dataset.fpReady === '1') return;
      root.dataset.fpReady = '1';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('.fp__tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.fp__panel'));
      var prev = root.querySelector('.fp__nav--prev');
      var next = root.querySelector('.fp__nav--next');

      function activePanel() { return root.querySelector('.fp__panel.is-active'); }
      function step(track) {
        if (!track) return 300;
        var card = track.querySelector('.fp__card');
        if (!card) return 300;
        var cs = getComputedStyle(track);
        var gap = parseInt(cs.columnGap || cs.gap || '0', 10) || 0;
        return card.offsetWidth + gap;
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-i');
          tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-i') === i); });
          var track = activePanel() ? activePanel().querySelector('.fp__track') : null;
          if (track) track.scrollTo({ left: 0 });
        });
      });

      if (prev) prev.addEventListener('click', function () {
        var track = activePanel() ? activePanel().querySelector('.fp__track') : null;
        if (track) track.scrollBy({ left: -step(track), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        var track = activePanel() ? activePanel().querySelector('.fp__track') : null;
        if (track) track.scrollBy({ left: step(track), behavior: 'smooth' });
      });
    }
    document.querySelectorAll('.fp').forEach(initFp);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.fp'); if (el) initFp(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-encabezado"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader(root) {
      if (!root || root.dataset.phdReady === '1') return;
      root.dataset.phdReady = '1';

      var burger = root.querySelector('.phd__burger');
      var drawer = root.querySelector('.phd__drawer');
      function openD() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
      function closeD() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
      if (burger) burger.addEventListener('click', openD);
      if (drawer) {
        drawer.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', closeD); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeD(); });
      }

      // Ocultar al bajar / mostrar al subir
      if (root.getAttribute('data-position') === 'ocultar') {
        var last = window.pageYOffset;
        window.addEventListener('scroll', function () {
          var y = window.pageYOffset;
          if (y > last && y > 120) root.classList.add('is-hidden');
          else root.classList.remove('is-hidden');
          last = y;
        }, { passive: true });
      }
    }
    document.querySelectorAll('.phd').forEach(initHeader);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.phd'); if (el) initHeader(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-garantia"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWg(root) {
      if (!root || root.dataset.wgReady === '1') return;
      root.dataset.wgReady = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('.wg__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.wg__dot'));
      var prev = root.querySelector('.wg__nav--prev');
      var next = root.querySelector('.wg__nav--next');
      if (slides.length <= 1) return;

      var current = 0, timer = null;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = (parseFloat(root.getAttribute('data-speed')) || 5) * 1000;

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
      }
      function nextSlide() { show(current + 1); }
      function start() { if (autoplay) { stop(); timer = setInterval(nextSlide, speed); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
      if (next) next.addEventListener('click', function () { show(current + 1); start(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-i'), 10) || 0); start(); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    }
    document.querySelectorAll('.wg').forEach(initWg);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.wg');
      if (el) initWg(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-preguntas-frecuentes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (!root || root.dataset.faqReady === '1') return;
      root.dataset.faqReady = '1';
      var single = root.getAttribute('data-single') === 'true';
      if (!single) return;
      var items = Array.prototype.slice.call(root.querySelectorAll('.pfaq__item'));
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) {
            items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
          }
        });
      });
    }
    document.querySelectorAll('.pfaq').forEach(initFaq);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.pfaq');
      if (el) initFaq(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-suscripcion-klaviyo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initKform(form) {
      if (!form || form.dataset.kReady === '1') return;
      form.dataset.kReady = '1';

      var msg = form.querySelector('.pkf__msg');
      var btn = form.querySelector('.pkf__submit');
      var company = form.getAttribute('data-company');
      var listId = form.getAttribute('data-list');

      function show(type, text) {
        msg.className = 'pkf__msg is-' + type;
        msg.textContent = text;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Trampa anti-spam
        var hp = form.querySelector('.pkf__hp');
        if (hp && hp.value) { return; }

        if (!company || !listId) {
          show('err', 'Falta configurar Klaviyo (Public API Key y List ID) en la sección.');
          return;
        }

        var fields = Array.prototype.slice.call(form.querySelectorAll('[data-kmap]'));
        var attrs = { properties: {} };
        var email = '';
        var missing = false;

        fields.forEach(function (f) {
          var map = f.getAttribute('data-kmap');
          var prop = f.getAttribute('data-kprop');
          var val;
          if (f.type === 'checkbox') { val = f.checked ? 'true' : ''; }
          else { val = (f.value || '').trim(); }

          if (f.hasAttribute('required') && !val) { missing = true; f.classList.add('pkf--invalid'); }
          else { f.classList.remove('pkf--invalid'); }

          if (!val) return;
          if (map === 'email') { email = val; attrs.email = val; }
          else if (map === 'first_name') { attrs.first_name = val; }
          else if (map === 'last_name') { attrs.last_name = val; }
          else if (map === 'phone_number') { attrs.phone_number = val; }
          else { attrs.properties[prop || 'Campo'] = val; }
        });

        if (missing) { show('err', 'Por favor completa los campos obligatorios (*).'); return; }
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { show('err', 'Ingresa un correo válido.'); return; }
        if (Object.keys(attrs.properties).length === 0) { delete attrs.properties; }

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.getAttribute('data-source') || 'Formulario web',
              profile: { data: { type: 'profile', attributes: attrs } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };

        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = '...';
        msg.className = 'pkf__msg';

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          btn.disabled = false;
          btn.textContent = original;
          if (r.ok) {
            show('ok', form.getAttribute('data-ok') || '¡Gracias! Te has suscrito correctamente.');
            form.reset();
          } else {
            r.text().then(function () {
              show('err', form.getAttribute('data-err') || 'No pudimos completar tu suscripción. Inténtalo de nuevo.');
            });
          }
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          show('err', form.getAttribute('data-err') || 'No pudimos completar tu suscripción. Inténtalo de nuevo.');
        });
      });
    }

    document.querySelectorAll('.pkf__form').forEach(initKform);
    document.addEventListener('shopify:section:load', function (e) {
      var f = e.target.querySelector('.pkf__form');
      if (f) initKform(f);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-videos-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPugc(root) {
      if (!root || root.dataset.pugcReady === '1') return;
      root.dataset.pugcReady = '1';

      var track = root.querySelector('.pugc__track');
      var prev = root.querySelector('.pugc__nav--prev');
      var next = root.querySelector('.pugc__nav--next');

      function step() {
        var card = track && track.querySelector('.pugc__card');
        if (!card) return 300;
        var cs = getComputedStyle(track);
        var gap = parseInt(cs.columnGap || cs.gap || '0', 10) || 0;
        return card.offsetWidth + gap;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      var modal = root.querySelector('.pugc__modal');
      var mMedia = root.querySelector('.pugc__modal-media');
      var mInfo = root.querySelector('.pugc__modal-info');

      function buildInfo(card) {
        mInfo.innerHTML = '';
        var ptitle = card.getAttribute('data-ptitle');
        if (ptitle) {
          var wrap = document.createElement('div');
          wrap.className = 'pugc__modal-product';
          var pimg = card.getAttribute('data-pimg');
          if (pimg) {
            var im = document.createElement('img');
            im.src = pimg; im.alt = '';
            wrap.appendChild(im);
          }
          var txt = document.createElement('div');
          txt.className = 'pugc__modal-ptxt';
          var a = document.createElement('a');
          a.className = 'pugc__modal-ptitle';
          a.href = card.getAttribute('data-purl') || '#';
          a.textContent = ptitle;
          var pr = document.createElement('span');
          pr.className = 'pugc__modal-pprice';
          pr.textContent = card.getAttribute('data-pprice') || '';
          txt.appendChild(a); txt.appendChild(pr);
          wrap.appendChild(txt);
          mInfo.appendChild(wrap);
        }
        var form = card.querySelector('.pugc__cart');
        if (form) mInfo.appendChild(form.cloneNode(true));
      }

      function openModal(card) {
        if (!modal) return;
        mMedia.innerHTML = '';
        var src = card.getAttribute('data-video');
        if (src) {
          var v = document.createElement('video');
          v.src = src;
          v.controls = true;
          v.autoplay = true;
          v.setAttribute('playsinline', '');
          mMedia.appendChild(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          var poster = card.querySelector('.pugc__poster');
          if (poster && poster.tagName === 'IMG') {
            var img = document.createElement('img');
            img.src = poster.getAttribute('src');
            img.alt = '';
            mMedia.appendChild(img);
          }
        }
        buildInfo(card);
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        if (!modal) return;
        var v = mMedia.querySelector('video');
        if (v) v.pause();
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        mMedia.innerHTML = '';
        mInfo.innerHTML = '';
      }

      root.querySelectorAll('.pugc__media').forEach(function (m) {
        m.addEventListener('click', function () { openModal(m.closest('.pugc__card')); });
      });
      if (modal) {
        modal.querySelector('.pugc__modal-close').addEventListener('click', closeModal);
        modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
      }
    }

    document.querySelectorAll('.pugc').forEach(initPugc);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.pugc');
      if (el) initPugc(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
